document.addEventListener("DOMContentLoaded", (event) => {
  var megamenu_product_carousel = document.querySelectorAll(
    ".mega-menu--product-carousel.swiper-container"
  );

  megamenu_product_carousel.forEach((carousel) => {
    let slidesPerView = $(carousel)
      .closest("[data-mega-menu--links-size]")
      .attr("data-mega-menu--links-size");
    if (slidesPerView < 3) {
      slidesPerView = 2;
    } else {
      slidesPerView = 1;
    }
    new Swiper(carousel, {
      // Optional parameters
      slidesPerView: slidesPerView,
      speed: 1000,

      // Navigation arrows
      navigation: {
        nextEl: `.swiper-button-next-${carousel.getAttribute("data-id")}`,
        prevEl: `.swiper-button-prev-${carousel.getAttribute("data-id")}`,
      },
    });
  });
});
